module.exports = __webpack_public_path__ + "static/img/manual-39.49ceee0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/mobile/manual-39.png
// module id = 1IjM
// module chunks = 4